import type { DirectiveBinding } from 'vue'

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    let startX = 0
    let startY = 0
    let initialMouseX = 0
    let initialMouseY = 0
    let isDragging = false

    const transition = el.style.transition

    const allowedDirection = binding.value

    if (allowedDirection === 'none') {
      return
    }

    const onMouseDown = (e: MouseEvent) => {
      initialMouseX = e.clientX
      initialMouseY = e.clientY
      startX = el.offsetLeft
      startY = el.offsetTop

      isDragging = false

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    }

    const onMouseMove = (e: MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      // el.style.position = allowedDirection === 'fixed' ? 'fixed' : 'absolute'
      const dx = e.clientX - initialMouseX
      const dy = e.clientY - initialMouseY

      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        isDragging = true

        // 计算新的位置
        let newX = startX + dx
        let newY = startY + dy

        // 获取窗口宽度和高度
        const windowWidth = window.innerWidth
        const windowHeight = window.innerHeight

        // 获取元素的宽度和高度
        const elWidth = el.offsetWidth
        const elHeight = el.offsetHeight

        // 边界检查，确保不会超出屏幕
        if (newX < 0) newX = 0
        if (newY < 0) newY = 0
        if (newX + elWidth > windowWidth) newX = windowWidth - elWidth
        if (newY + elHeight > windowHeight) newY = windowHeight - elHeight

        // 更新元素的位置
        if (allowedDirection !== 'onlyY') {
          if (el.style.right) {
            el.style.setProperty('right', `${windowWidth - elWidth - newX}px`, 'important')
            // el.style.right = `${windowWidth - elWidth - newX}px`
          } else {
            el.style.right = `${newX}px`
          }
        }
        el.style.top = `${newY}px`
        el.style.transition = 'none'
      }
    }

    const onMouseUp = () => {
      el.style.transition = transition
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }

    const onClick = (e: MouseEvent) => {
      if (isDragging) {
        e.stopImmediatePropagation()
      }
    }

    // 初始化元素样式
    el.style.position = 'absolute'
    el.style.cursor = 'move'

    // 监听事件
    el.addEventListener('mousedown', onMouseDown)
    el.addEventListener('click', onClick, true)
  },
}
